import styled from 'styled-components'
import Image from 'common/image'
import { useTranslation } from 'react-i18next'

const BoxContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 1164px;
    height: 478px;
    padding: 48px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const FirstLineText = styled.div`
    padding-top: 32px;
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const SuggestionItemRow = styled.div`
    padding-top: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 35px;
`

const SuggestionItem = styled.div`
    display: flex;
    flex-direction: row;
    width: 330px;
    height: 100px;
    gap: 12px;
    align-items: center;
`
const SuggestionText = styled.div`
    color: #4e3821;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 143.75% */
`

export default function AccumlateWins() {
    const { t } = useTranslation('', { keyPrefix: 'earnwins.accumulatewins' })

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t('title')}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <FirstLineText>{t('description')}</FirstLineText>
            <SuggestionItemRow>
                <SuggestionItem>
                    <Image
                        src={t('item1Icon')}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionText>{t('item1desc')}</SuggestionText>
                </SuggestionItem>
                <SuggestionItem>
                    <Image
                        src={t('item2Icon')}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionText>{t('item2desc')}</SuggestionText>
                </SuggestionItem>
                <SuggestionItem>
                    <Image
                        src={t('item3Icon')}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionText>{t('item3desc')}</SuggestionText>
                </SuggestionItem>
            </SuggestionItemRow>
            <SuggestionItemRow>
                <SuggestionItem>
                    <Image
                        src={t('item4Icon')}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionText>{t('item4desc')}</SuggestionText>
                </SuggestionItem>
                <SuggestionItem>
                    <Image
                        src={t('item5Icon')}
                        width={100}
                        height={100}
                        alt="account icon"
                    />
                    <SuggestionText>{t('item5desc')}</SuggestionText>
                </SuggestionItem>
            </SuggestionItemRow>
        </BoxContainer>
    )
}
